<div class="container">
  <div class="forbidden">
    <div class="forbidden__403">
      <img src=" ./assets/forbidden/forbidden.svg" alt="Forbidden SVG" />
    </div>

    <div class="forbidden__content">
      <h1 class="forbidden__title">
        {{ "components.forbidden.title" | transloco }}
      </h1>

      <ng-container *ngIf="isExpired; else noAccess">
        <p class="forbidden__text">
          {{ "components.forbidden.expired" | transloco }}
          <a class="forbidden__link" href="mailto:FCS-C-support@mercedes-benz.com"
            >FCS-C-support&#64;mercedes-benz.com</a
          >
        </p>
      </ng-container>

      <ng-template #noAccess>
        <p class="forbidden__text">
          {{ "components.forbidden.subtite-1" | transloco }}<br />
          {{ "components.forbidden.subtite-2" | transloco }}
          <a
            class="forbidden__link"
            href="https://social.cloud.corpintra.net/groups/itsg/blog/2025/04/14/introducing-fcs-c-and-how-to-gain-access"
            >https://social.cloud.corpintra.net/groups/itsg/blog/2025/04/14/introducing-fcs-c-and-how-to-gain-access</a
          >
        </p>
      </ng-template>
    </div>
  </div>
</div>

<div class="outer-container">
  <div class="minimum-height"></div>
</div>
